module.exports = __webpack_public_path__ + "img/warning-big.0ce59e83.svg";